import { AnyFeedItemEntityVersion, FeedItem, FirestoreEntity, Mapper } from '@uploadcam/common';
import { CollectionReference, onSnapshot, query, where } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { FeedFilter } from './get-team-feed.interactor';
import { createFeedQuery } from '../helpers/create-feed-query';

export class GetTeamFeedUpdatesInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyFeedItemEntityVersion>,
    private readonly mapper: Mapper<unknown, FeedItem>,
  ) {}

  public async execute(teamId: string, filter?: FeedFilter): Promise<Observable<FeedItem>> {
    return new Observable((subscriber) => {
      const feedQuery = [...createFeedQuery(teamId, filter), where('createdAt', '>', new Date())];

      const unsubscribe = onSnapshot(query(this.collection, ...feedQuery), (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            subscriber.next(this.mapper.map(FirestoreEntity.from(change.doc)));
          }
        });
      });

      return () => unsubscribe();
    });
  }
}
